export const state = () => ({});

export const getters = {
  getHeaderNav: (state, getters, rootState, rootGetters) => {
    const currentGender = rootGetters["global/getCurrentGender"] || "female";

    return [
      {
        id: 1,
        name: "Live feed",
        link: "/escorts-updates",
        isShowMobile: true,
      },
      {
        id: 2,
        name: "Reviews",
        link: "/reviews",
        isShowMobile: true,
      },
      {
        id: 3,
        name: "Video",
        link: "/escorts-videos",
        isShowMobile: true,
      },
      {
        id: 4,
        name: "Photo",
        link: "/escorts-photo-gallery",
        isShowMobile: true,
      },
      {
        id: 5,
        name: "News",
        link: "/escorts-news",
        isShowMobile: true,
      },
      {
        id: 6,
        name: "Categories",
        link: `/categories/${currentGender}`,
        isShowMobile: true,
      },
    ];
  },

  getFooterNav: (state, getters, rootState, rootGetters) => {
    const catalogUrl = rootGetters["global/getCurrentLocationUrl"];
    const currentGender = rootGetters["global/getCurrentGender"] || "female";

    return [
      {
        id: 0,
        name: "Girls",
        link: `/${catalogUrl}/${currentGender}`,
        isShowMobile: true,
      },
      {
        id: 1,
        name: "Live feed",
        link: "/escorts-updates",
        isShowMobile: true,
      },
      {
        id: 2,
        name: "Reviews",
        link: "/reviews",
        isShowMobile: true,
      },
      {
        id: 3,
        name: "Photo",
        link: "/escorts-photo-gallery",
        isShowMobile: true,
      },
      {
        id: 4,
        name: "Video",
        link: "/escorts-videos",
        isShowMobile: true,
      },
      {
        id: 5,
        name: "News",
        link: "/escorts-news",
        isShowMobile: true,
      },
      {
        id: 6,
        name: "Categories",
        link: `/categories/${currentGender}`,
        isShowMobile: true,
      },
    ];
  },

  getHeaderGenderNav: (state, getters, rootState, rootGetters) => {
    const catalogUrl = rootGetters["global/getCurrentLocationUrl"];
    const currentGender = rootGetters["global/getCurrentGender"] || "female";

    return {
      id: 7,
      name: "Catalog",
      link: `/${catalogUrl}/${currentGender}`,
      isShowMobile: false,
      subMenu: [
        { id: 96, name: "Female", link: `/${catalogUrl}/female` },
        { id: 97, name: "Shemale", link: `/${catalogUrl}/transgender` },
        { id: 98, name: "Male", link: `/${catalogUrl}/male` },
        { id: 99, name: "All", link: "/" + catalogUrl },
      ],
    };
  },
};

export const mutations = {};

export const actions = {};
